import { render, staticRenderFns } from "./dspOverview.vue?vue&type=template&id=48058a4e&scoped=true&"
import script from "./dspOverview.vue?vue&type=script&lang=js&"
export * from "./dspOverview.vue?vue&type=script&lang=js&"
import style0 from "./dspOverview.vue?vue&type=style&index=0&id=48058a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48058a4e",
  null
  
)

export default component.exports